import FindFolderRequest from 'owa-service/lib/contract/FindFolderRequest';
import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import findFolderOperation from 'owa-service/lib/operation/findFolderOperation';
import findFolderRequest from 'owa-service/lib/factory/findFolderRequest';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';

const HEADER_EXPLICIT_LOGON_USER: string = 'X-OWA-ExplicitLogonUser';
const HEADER_ANCHOR_MAILBOX: string = 'X-AnchorMailbox';

export default function findSharedFolders(
    baseFolderIds: BaseFolderId[],
    principalSMTPAddress: string
): Promise<FindFolderResponseMessage> {
    let requestBody = configureRequestBody(baseFolderIds);
    return findFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        getExplicitUserHeaders(principalSMTPAddress)
    ).then(response => {
        // In the FindFolderAction, the first folder is the principal's root node.
        // The second folder is the principal's Inbox.
        // For shared folder scenario, when the delegate has access to the principal's root,
        // we should load all the folders visible to the delegate under the principal's root.
        // When the delegate only has access to the principal's Inbox, but not the root, the response of the first folder will be null.
        if (
            response.Body.ResponseMessages.Items[0] &&
            response.Body.ResponseMessages.Items[0].ResponseClass !== 'Success' &&
            response.Body.ResponseMessages.Items.length > 1
        ) {
            return response.Body.ResponseMessages.Items[1] as FindFolderResponseMessage;
        }

        return response.Body.ResponseMessages.Items[0] as FindFolderResponseMessage;
    });
}

function configureRequestBody(baseFolderIds: BaseFolderId[]): FindFolderRequest {
    return findFolderRequest({
        FolderShape: folderResponseShape({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri({ FieldURI: 'DistinguishedFolderId' }),
                propertyUri({ FieldURI: 'FolderClass' }),
                propertyUri({ FieldURI: 'FolderDisplayName' }),
                propertyUri({ FieldURI: 'ParentFolderId' }),
                propertyUri({ FieldURI: 'TotalCount' }),
                propertyUri({ FieldURI: 'UnreadCount' }),
            ],
        }),
        Paging: null,
        ParentFolderIds: baseFolderIds,
        ReturnParentFolder: true,
        ShapeName: 'Folder',
        Traversal: 'Deep',
    });
}

function getExplicitUserHeaders(principalSMTPAddress: string) {
    return {
        headers: <any>{
            [HEADER_EXPLICIT_LOGON_USER]: principalSMTPAddress,
            [HEADER_ANCHOR_MAILBOX]: principalSMTPAddress,
        },
    };
}
